"use strict";
import { spacing } from "ui/src/theme";
export const SWITCH_THUMB_HEIGHT = spacing.spacing24;
export const SWITCH_THUMB_PADDING = spacing.spacing4;
export const SWITCH_TRACK_HEIGHT = SWITCH_THUMB_HEIGHT + SWITCH_THUMB_PADDING * 2;
export const SWITCH_TRACK_WIDTH = spacing.spacing60;
